import { Link } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { AskSparkle } from '../../../components/ask/AskSparkle';

interface ActionBarProps {
  onShowReward: () => void;
  /** Opens Dr Cleanstein; omitted for people without an allowance. */
  onShowAsk?: () => void;
}

/**
 * Mobile Bottom Action Bar
 * Buttons: Reward / Book / Log / Cert, plus Ask for people with a Dr Cleanstein allowance
 * Hidden on desktop, visible on mobile (<=768px)
 */
function ActionBar({ onShowReward, onShowAsk }: ActionBarProps) {
  const { hasPermission } = useAuth();

  // Referral codes are auto-created, so sharing one is a view-level action.
  // Voucher creation stays at contribute. Operators (referrals: view) get the
  // button to share existing codes; the speed dial hides the create options.
  const canReward = hasPermission('vouchers', 'contribute') || hasPermission('referrals', 'view');
  const canBook = hasPermission('bookings', 'contribute');
  const canLog = hasPermission('service_logs', 'contribute');
  const canCert = hasPermission('certification', 'contribute');

  return (
    <div className="mobile-action-bar">
      {canReward && (
        <button
          className="mobile-action-btn"
          onClick={onShowReward}
          type="button"
        >
          <span className="mobile-action-btn-icon">🎁</span>
          <span className="mobile-action-btn-label">Reward</span>
        </button>
      )}

      {canBook && (
        <Link to="/bookings?create=true" className="mobile-action-btn">
          <span className="mobile-action-btn-icon">📅</span>
          <span className="mobile-action-btn-label">Book</span>
        </Link>
      )}

      {canLog && (
        <Link to="/service-logs/new" className="mobile-action-btn">
          <span className="mobile-action-btn-icon">📋</span>
          <span className="mobile-action-btn-label">Log</span>
        </Link>
      )}

      {canCert && (
        <Link to="/certification/submit" className="mobile-action-btn">
          <span className="mobile-action-btn-icon">📜</span>
          <span className="mobile-action-btn-label">Cert</span>
        </Link>
      )}

      {onShowAsk && (
        <button className="mobile-action-btn" onClick={onShowAsk} type="button">
          <span className="mobile-action-btn-icon"><AskSparkle /></span>
          <span className="mobile-action-btn-label">Ask</span>
        </button>
      )}
    </div>
  );
}

export default ActionBar;
